import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../core/services/authentication/auth.service';
import { AlertComponent } from '../shared/components/alert/alert.component';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  imports: [AlertComponent],
})
export class AuthCallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  error: boolean;

  async ngOnInit() {
    try {
      // check for error
      if (this.route.snapshot.fragment.indexOf('error') >= 0) {
        this.error = true;
        return;
      }

      await this.authService.completeAuthentication();
      this.runApp();
    } catch {
      window.location.replace(window.location.origin);
      // this.appIntroService.initErrorToggle();
    }
  }

  runApp() {
    this.router.navigate(['/']);
  }
}
